import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import global_en from './translations/en/global.json';
import global_sk from './translations/sk/global.json';
import global_cz from './translations/cz/global.json';

import i18next from 'i18next';
import App from './App';

import './assets/fonts/fonts.css';
import './css/root.css';
import './css/main.css';
import './css/tab_menu.css';
import './css/user_menu_override.css';
import './css/typing.css';

import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { NotificationProvider } from './context/NotificationContext';
import {PublicClientApplication} from "@azure/msal-browser";
import config from "./config/configJS";

i18next.init({
  interpolation: { escapeValue: true },
  lng: 'en',
  resources: {
    en: { global: global_en },
    sk: { global: global_sk },
    cz: { global: global_cz }
  },
});

const adConfig = config.adConfig;
const msalInstance = new PublicClientApplication({
  auth: adConfig
});

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('msalInstance', msalInstance);
root.render(
  <BrowserRouter basename="/">
    <I18nextProvider i18n={i18next}>
      <MsalProvider instance={msalInstance}>
      <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route path="/*" element={ <App/> } />
        </Routes>     
        </NotificationProvider>
      </AuthProvider>
      </MsalProvider>
    </I18nextProvider>   
  </BrowserRouter>
);

reportWebVitals();
